import { Modal } from 'antd';
import { useState, memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import ModalHeader from './Modal-header/ModalHeader';
import ModalContent from './Modal-content/ModalContent';
import Icons from '../../../configs/icon.config';
import ModalFooter from './Modal-footer/ModalFooter';
import Caption from '../Caption/Caption';
import { Search } from '../Search/Search';
import { RoundedIcon } from '../Rounded-icon/RoundedIcon';
import SearchContextProvider from '../Search/Context/SearchContext';
import Translate from '../Translate';

interface ModalProps {
  visible?: boolean;
  onClose?: () => void;
}

function CustomModal({ visible, onClose }: ModalProps) {
  const [searchValue, setSearchValue] = useState('');
  const [tabKey, setTabKey] = useState<string>('BDC');
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const handleSearch = (value: string) => {
    setSearchValue(value);
  };

  const handleTabChange = (value: string) => {
    setTabKey(value);
  };

  return (
    <Modal
      open={visible}
      // bodyStyle={{
      //   overflowY: 'scroll',
      //   height: 'calc(100vh - 250px)',
      // }}
      width={900}
      // closable={false}
      centered
      footer={false}
      // footer={[
      //   <ModalFooter
      //     key={1}
      //     buttonText="Back"
      //     buttonIcon={Icons.back}
      //     onCancel={onClose}
      //   />,
      // ]}
      onCancel={onClose}
    >
      <ModalHeader
        // onCancel={() => onClose?.()}
        caption={
          <Caption
            text_en="Important contacts"
            text_bn="জরুরী ফোন নম্বর"
            fontSize="3xl"
            fontWeight="bold"
            color="gray-800"
          />
        }
        search={
          <Search
            onSearch={handleSearch}
            classname="contacts-search"
            width={isMobile ? 300 : 450}
            options={[]}
            placeholder={
              <Translate
                en={`Search in ${tabKey}`}
                bn={`${tabKey} এর মধ্যে খুঁজুন`}
              />
            }
            foundContent={false}
          />
        }
        iconSearch={
          <RoundedIcon
            iconName={Icons.search}
            classname="search-button"
            width={25}
            height={25}
          />
        }
      />
      <div
        style={{
          overflowY: 'auto',
          overflowX: 'hidden',
          minHeight: '400px',
          maxHeight: 'calc(100vh - 250px)',
        }}
      >
        <SearchContextProvider value={searchValue}>
          <ModalContent handleTabChange={handleTabChange} />
        </SearchContextProvider>
      </div>
      <div className="mt-10">
        <ModalFooter
          key={1}
          buttonText={<Translate en="Back" bn="পেছনে যান" />}
          buttonIcon={Icons.back}
          onCancel={onClose}
        />
      </div>
    </Modal>
  );
}

export default memo(CustomModal);
